<template>
    <div class="bgray-400 min-vh-100">
        <b-navbar
            class="d-flex justify-content-between align-items-center py-2 px-5 bgray-700 gray-300 shadow w-100"
            sticky
            >
            <b-button :variant="GETTER_IS_PREMIUM == false ? 'dark' : 'half-bg-light'"
                class="py-1 px-2 f-90"    
                @click="$router.push({ name: return_name })"
                >
                <fa icon="arrow-left" class="mr-1"></fa> 문서뷰어 닫기
            </b-button>

            <template v-if="isLoading"> Loading... </template>
            <template v-else>
                <div v-if="showEachPages">
                    <b-button v-if="GETTER_IS_PREMIUM == true"
                        :disabled="page <= 1"
                        variant="half-bg-light"
                        class="py-0 px-2 mr-1"
                        @click="page--"
                        >
                        ❮
                    </b-button>
                    {{ page }} / {{ pageCount }}
                    <b-button v-if="GETTER_IS_PREMIUM == true"
                        :disabled="page >= pageCount"
                        variant="half-bg-light"
                        class="py-0 px-2 ml-1"
                        @click="page++"
                        >
                        ❯
                    </b-button>
                </div>
                <div v-else> 총 {{ pageCount }} 페이지 </div>
            </template>
            <div class="d-flex">
                <b-button variant="half-bg-light"
                    class="mr-2 py-1 px-2 f-90"
                    :disabled="GETTER_IS_PREMIUM == false"
                    @click="expand_x = !expand_x"
                    >
                    <fa :icon="expand_x == true ? 'arrows-alt-v' : 'arrows-alt-h'"
                    class="mr-1" />
                    {{ expand_x == true ? '세로 맞춤' : '가로 맞춤'}}
                </b-button>
                <b-button
                    variant="half-bg-light"
                    class="mr-2 py-1 px-2 f-90"    
                    :disabled="GETTER_IS_PREMIUM == false"
                    @click="showEachPages = !showEachPages"
                    >
                    {{ showEachPages == true ? '스크롤 다운' : '한페이지씩' }}
                </b-button>
            </div>
        </b-navbar>

        <div v-if="this.source != null" class="p-4 position-relative">
            <vue-pdf-embed ref="pdfRef" :source="this.source" :page="page" @rendered="handleDocumentRender"
                class="display-pdf-standard mb-2" :class="expand_x == true ? 'expand_x' : 'expand_y'" />
            <div v-if="GETTER_IS_PREMIUM == false"
                class="position-absolute standard-viewer-to-premium d-flex flex-column align-items-center justify-content-center text-center pb-5">
                <h3 class="gray-100 mb-4">본 자료는 프리미엄 회원에게만 제공되는 서비스입니다. <br>
                    프리미엄 서비스 가입 후 이용해주세요.</h3>
                <b-button size="lg" variant="teal" class="mb-5 shadow" @click="$router.push({ name: 'AddToCart' })"> 프리미엄 서비스
                    가입하기 </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import {requirePresignedUrl} from '@core_utils/api/file_api.js'
export default {
    name: 'PDFStandardViewer',
    components: {
        VuePdfEmbed,
    },
    data() {
        return {
            pdf_source: '[QESG] ESG 기본개념_v1.pdf',
            return_name: 'Main',
            isLoading: true,
            page: null,
            pageCount: 1,
            showEachPages: false,
            expand_x: false,
            source: null
        }
    },
    computed: {
        ...mapGetters('payment', ['GETTER_IS_PREMIUM'])
    },
    watch: {
        showEachPages() {
            this.page = this.showEachPages ? 1 : null
        }
    },
    created() {
        if (this.$route.params.pdf_src) {
            this.pdf_source = this.$route.params.pdf_src
            this.return_name = this.$route.params.return_name

            requirePresignedUrl(this.pdf_source)
                .then((url) => {
					//pdf_src를 바로 사용하지않고
					//presigned_url을 요청하는데 사용한다.
					//그리고 결과값을 source에 저장하여
					//이를 통해 pdf를 띄운다.
                    this.source = url
                })
        }

        if (this.GETTER_IS_PREMIUM == false) {
            this.showEachPages = true
            this.page = 1
        }
    },    
    methods: {
        handleDocumentRender() {
            this.isLoading = false
            this.pageCount = this.$refs.pdfRef.pageCount
        },
    },

}
</script>

<style>
.display-pdf-standard>div {
    margin-bottom: 1rem;
}

.display-pdf-standard>div>canvas {
    box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
    margin-left: auto;
    margin-right: auto;
}

.display-pdf-standard.expand_y>div>canvas {
    width: auto !important;
    max-height: calc(100vh - 7.5rem) !important;
}

.display-pdf-standard.expand_x>div>canvas {
    height: auto !important;
    max-width: calc(100vw - 3rem) !important;
}

.standard-viewer-to-premium {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}</style>